import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog11 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Intro */}
        <p className="paragraph-content">
          Whether you’re a fresher with your first salary, or a family man tired
          of traffic jams –
          <br />
          a two-wheeler isn’t just a ride. It’s freedom on two wheels.
          <br />
          But the real question is – how do you buy smartly, not hastily?
        </p>

        <p className="paragraph-content">
          A lot of people rush in – easy loans, shiny bikes, instant regret.
          <br />
          Why? Missed EMIs, hidden charges, or biting off more than they can
          pay.
          <br />
          Buying a bike should feel exciting, not exhausting.
        </p>

        <p className="paragraph-content">
          Imagine this –
          <br />
          You walk into the showroom, pick your ride, and walk out knowing you
          got the best deal, the best plan, and zero stress.
          <br />
          That’s what smart financing feels like.
        </p>

        {/* Rules */}
        <p className="paragraph-heading">🧠 4 Simple Rules Before You Buy</p>

        <p className="sub-paragraph-heading">1️⃣ Choose the Right Finance Fit</p>

        <p className="paragraph-content">Two main tools:</p>

        <ul>
          <li style={{ marginBottom: 10, color: "black" }}>
            <b>Two-Wheeler Loan:</b> Lower rate, but fixed for the vehicle.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            <b>Personal Loan (via kPaisa):</b> Flexible, quick, zero down
            payment.
          </li>
        </ul>

        <p className="paragraph-content">
          Compare rates, EMIs, and tenure.
          <br />
          Don’t pick what’s popular – pick what’s practical.
        </p>

        <p className="sub-paragraph-heading">2️⃣ Borrow Only What You Need</p>

        <p className="paragraph-content">
          Just because you can borrow ₹1 lakh doesn’t mean you should.
          <br />
          Plan your EMI – use kPaisa’s calculator, check your monthly cash flow,
          and leave room for emergencies.
        </p>

        <p className="sub-paragraph-heading">3️⃣ Time It Right</p>

        <p className="paragraph-content">
          Festive season = goldmine for offers.
          <br />
          <br />
          Free accessories, insurance, low processing fees –
          <br />
          grab the deals that matter, not the ones that dazzle.
        </p>

        <p className="sub-paragraph-heading">
          4️⃣ Plan Repayment Before the Ride
        </p>

        <p className="paragraph-content">
          Set auto-debit, pay more upfront if you can, and close early when
          possible.
          <br />
          Less tenure = less tension.
          <br />
          <br />
          The truth? Anyone can buy a bike.
          <br />
          But owning it without financial stress – that’s the real win.
          <br />
          <br />
          With kPaisa, you can apply for an instant two-wheeler loan, get
          flexible repayment, and even auto-save for EMIs – all from your phone.
          <br />
          <br />
          No forms. No waiting. Just you, your ride, and your peace of mind.
          <br />
          <br />
          There’s a small feature inside kPaisa that secretly helps users close
          their loans faster. You’ll notice it when your last EMI arrives sooner
          than you expected. 😉
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">
            Can I get a bike loan with a small salary?
          </h4>
          <p className="faq-answer">
            Yes! kPaisa’s flexible limits make it easy to start even with modest
            income – approval is instant and fully digital.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Is a personal loan better than a bike loan?
          </h4>
          <p className="faq-answer">
            If you want flexibility – yes. kPaisa’s personal loan lets you use
            funds for your bike and other needs, without tying you to one
            purchase.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">Can I repay early?</h4>
          <p className="faq-answer">
            Absolutely. You can pre-close anytime with no hidden penalties –
            save interest and own your bike faster.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog11;
